import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useDeleteEstablishmentCompanyMaintenanceSpecification } from "@/features/establishments/hooks/maintenanceModels/useDeleteEstablishmentCompanyMaintenanceSpecification";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface DeleteMaintenanceSpecificationModalProps {
  establishmentCompany: EstablishmentCompanyData;
  maintenanceSpecification: EstablishmentCompanyData['maintenance_specifications'][number];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const DeleteMaintenanceSpecificationModal = ({
  establishmentCompany,
  maintenanceSpecification,
  isOpen,
  setIsOpen,
}: DeleteMaintenanceSpecificationModalProps) => {
  const queryClient = useQueryClient();
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteMaintenanceSpecification,
    isPending: deleteMaintenanceSpecificationIsPending,
  } = useDeleteEstablishmentCompanyMaintenanceSpecification({
    establishmentCompanyId: establishmentCompany.id,
    maintenanceSpecification,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentCompany', establishmentCompany.id] });

      setIsOpen(false);
    },
    onError: FormTransformers.errorsTransformer({
      setMessages,
    }),
  });

  return (
    <div onClick={(event) => event.stopPropagation()}>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={deleteMaintenanceSpecification}
        confirmButtonIsLoading={deleteMaintenanceSpecificationIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </div>
  );
}

export default DeleteMaintenanceSpecificationModal;
